import gql from 'graphql-tag'
import {
  GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS,
  GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS,
  GQL_PROJECT_CHATGPT_RESPONSES_API_DEFAULT_FIELDS,
  GQL_PROJECT_DEFAULT_FIELDS
} from '@/components/projects/graphql/graphql.const.ts'

// TODO: Return project on backend
export const CreateOrUpdateProjectMutation = gql`
  mutation CreateOrUpdateProject ($input: CreateOrUpdateProjectInput!) {
    project: createOrUpdateProject (input: $input) {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }`

export const UpdateProjectSettingsMutation = gql`
  mutation UpdateProjectSettings ($projectId: Uint!, $input: ProjectSettingsInput!) {
    settings: updateProjectSettings (projectId: $projectId, input: $input) {
      widgetAssistantBehaviour {
        initialMessage
        delayBeforeResponseMs
        initialMessageTypingDelayMs
        initialMessageSendingDelayAfterTypingEndedMs
      }
      widgetVisual {
        color
        avatarUrl
        gradients {
          enabled
          degree
          colors
        }
        margins {
          horizontalPx
          verticalPx
          position
        }
      }
      widgetLocalization {
        default
        locale
        assistantName
        assistantBadge
        initialMessage
        userMessagePlaceholder
      }
      security {
        banIpChatsLimitChats
        maxChatsPerTimeChats
        maxChatsPerTimeSeconds
        aiQuitMessagesThreshold
        maxMessagesPerTimeSeconds
        maxMessagesPerTimeMessages
        maxChatMessagesPerTimeSeconds
        banIpChatsLimitIntervalSeconds
        maxChatMessagesPerTimeMessages
        maxChatMessagesPerTimeBanMinutes
        banIpChatsLimitIntervalBanTimeMinutes
      }
      common {
        chatAliveForXMinutes
      }
      ai {
        type
        chatGptInitialTask
      }
    }
  }
`

export const ActivateProjectMutation = gql`
  mutation ActivateProject ($id: Uint!) {
    project: activateProject (id: $id) {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }
`
export const DeactivateProjectMutation = gql`
  mutation DeactivateProject ($id: Uint!) {
    project: deactivateProject (id: $id) {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }
`
export const ArchiveProjectMutation = gql`
  mutation ArchiveProject ($id: Uint!) {
    project: archiveProject (id: $id) {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }
`
export const UnArchiveProjectMutation = gql`
  mutation UnarchiveProject ($id: Uint!) {
    project: unarchiveProject (id: $id) {
      ${GQL_PROJECT_DEFAULT_FIELDS}
    }
  }
`

export const UploadAssistantPhotoMutation = gql`
  mutation UploadAssistantPhoto($projectId: Uint!, $req: Upload!) {
    file: uploadAssistantPhoto (projectId: $projectId, req: $req) {
      path
    }
  }
`
export const UploadAiFilesMutation = gql`
  mutation UploadAiFiles($projectId: Uint!, $aiType: Uint!, $req: [Upload]!) {
    files: uploadAiFiles (projectId: $projectId, aiType: $aiType, req: $req) {
      ${GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS}
    }
  }
`

export const ProjectSettingsDeleteAssistantFile = gql`
  mutation DeleteAssistantFile ($projectId: Uint!, $aiType: Uint!, $fileKey: String!) {
    file: assistantFileDelete (projectId: $projectId, aiType:$aiType, fileKey: $fileKey) {
      ${GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS}
    }
  }
`

export const ProjectSettingsEnableAssistantFile = gql`
  mutation EnableAssistantFile ($projectId: Uint!, $aiType: Uint!, $fileKey: String!) {
    file: assistantFileEnable (projectId: $projectId, aiType: $aiType, fileKey: $fileKey) {
      ${GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS}
    }
  }
`

export const ProjectSettingsDisableAssistantFile = gql`
  mutation DisableAssistantFile ($projectId: Uint!, $aiType: Uint!, $fileKey: String!) {
    file: assistantFileDisable (projectId: $projectId, aiType: $aiType, fileKey: $fileKey) {
      ${GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS}
    }
  }
`

/* export const ProjectSettingsCreateChatGptAssistant = gql`
  mutation ProjectSettingsCreateChatGptAssistant ($projectId: Uint!) {
    assistantInfo: createChatGptAssistant (projectId: $projectId) {
      ${GQL_PROJECT_ASSISTANT_INFO_DEFAULT_FIELDS}
    }
  }
` */

export const ProjectSettingsUpdateChatGptResponsesApiSettings = gql`
  mutation UpdateChatChatGptAssistant ($projectId: Uint!, $form: ChatGptAssistantInfoInput!) {
    apiInfo: updateChatGptResponsesApiSettings (projectId: $projectId, form: $form) {
      ${GQL_PROJECT_CHATGPT_RESPONSES_API_DEFAULT_FIELDS}
    }
  }
`

export const UploadAssistantPhoto = gql`
  mutation UploadWidgetAssistantPhoto($projectId: Uint!, $req: Upload) {
    file: uploadWidgetAssistantPhoto (projectId: $projectId, req: $req) {
      ${GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS}
    }
  }
`

export const DeleteAssistantPhoto  = gql`
  mutation DeleteWidgetAssistantPhoto($projectId: Uint!, $fileKey: String!) {
    deleteWidgetAssistantPhoto(projectId: $projectId, fileKey: $fileKey) {
      succeed
    }
  }
`
